import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyDefaultFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.0848 14.0848C14.2813 14.0557 14.4562 14.0163 14.6209 13.9627C15.8894 13.5506 16.8839 12.5561 17.2961 11.2876C17.5 10.6599 17.5 9.8844 17.5 8.33333C17.5 6.78227 17.5 6.00673 17.2961 5.3791C16.8839 4.1106 15.8894 3.11609 14.6209 2.70393C13.9933 2.5 13.2177 2.5 11.6667 2.5C10.1156 2.5 9.34006 2.5 8.71243 2.70393C7.44394 3.11609 6.44942 4.1106 6.03726 5.3791C5.98374 5.54381 5.94427 5.71872 5.91516 5.91516M14.0848 14.0848C14.1667 13.5328 14.1667 12.8107 14.1667 11.6667C14.1667 10.1156 14.1667 9.34006 13.9627 8.71243C13.5506 7.44394 12.5561 6.44942 11.2876 6.03726C10.6599 5.83333 9.8844 5.83333 8.33333 5.83333C7.18933 5.83333 6.46721 5.83333 5.91516 5.91516M14.0848 14.0848C14.0557 14.2813 14.0163 14.4562 13.9627 14.6209C13.5506 15.8894 12.5561 16.8839 11.2876 17.2961C10.6599 17.5 9.8844 17.5 8.33333 17.5C6.78227 17.5 6.00673 17.5 5.3791 17.2961C4.1106 16.8839 3.11609 15.8894 2.70393 14.6209C2.5 13.9933 2.5 13.2177 2.5 11.6667C2.5 10.1156 2.5 9.34006 2.70393 8.71243C3.11609 7.44394 4.1106 6.44942 5.3791 6.03726C5.54381 5.98374 5.71872 5.94427 5.91516 5.91516",
		stroke: "#2563EB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 12.6636L7.34119 15L7.52825 14.6732C8.53118 12.9212 9.91916 11.4195 11.5875 10.2814L12 10",
		stroke: "#2563EB",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCopyDefaultFilled);
export default ForwardRef;
